import { memo, useCallback } from 'react';
import {
  Box,
  WebView,
  PressableIcon,
  useSafeAreaInsets,
} from '@bonanza-social/moonlight';
import { Platform } from 'react-native';
import { useNavigation } from '@bonanza-social/navigation';

type SmarticoPromoProps = {
  url: string;
};

function SmarticoPromo({ url }: SmarticoPromoProps) {
  const navigation = useNavigation();
  const { top, bottom } = useSafeAreaInsets();

  const handleClose = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  if (!url) {
    return null;
  }

  return (
    <Box flex={1}>
      <PressableIcon
        position="absolute"
        name="close"
        width="space-600"
        height="space-600"
        gradient="accentBackground"
        backgroundColor="transparent"
        top={Platform.select({
          ios: 'space-1800',
          web: 'space-400',
          android: 'space-1800',
        })}
        marginRight={Platform.select({
          ios: 'space-400',
          web: 'space-200',
          android: 'space-400',
        })}
        alignSelf="flex-end"
        zIndex={10}
        onPress={handleClose}
        testID="smartico-promo-close"
      />
      <WebView
        domStorageEnabled
        javaScriptEnabled
        sharedCookiesEnabled
        cacheEnabled={!__DEV__}
        webviewDebuggingEnabled={__DEV__}
        originWhitelist={['*']}
        source={{ uri: url }}
        injectedJavaScript={`
          document.documentElement.style.setProperty("--safe-area-inset-top", "${top}px");
          document.documentElement.style.setProperty("--safe-area-inset-bottom", "${bottom}px");
        `}
      />
    </Box>
  );
}

export default memo(SmarticoPromo);
